import { ConsumerTypeHelper } from '../consumer-types.helper'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { ConsumerTypeCreateEditController } from './consumer-types-create-edit.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './consumer-types-create-edit.tpl.html'

//#endregion

// #region Setup

export class ConsumerTypeCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', USER_SESSION_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        userSession: UserSessionService
    ) => new ConsumerTypeCreateEditController(
        $scope,
        $q,
        $timeout,
        userSession,
        ConsumerTypeHelper.REFERENCE_TYPE,
        ConsumerTypeHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// #endregion